import * as log from './log';
export var triggerOnPageLoadAnalytics = function (analytics, event) {
    if (typeof Bootstrapper === 'undefined') {
        console.error("Missing Omniture Analytics script. Please import '//nexus.ensighten.com/synchronyretail/dservicespadev/Bootstrap.js'...");
        return;
    }
    window._SFDDL = window._SFDDL || {};
    window._SFDDL.pageInfo = analytics;
    log.info('SPA-PageLoad', window._SFDDL, 'omniture');
    if (event !== null || event !== '' || event !== undefined) {
        Bootstrapper.ensEvent.trigger(event);
    }
};
export var updateAnalyticsObj = function (SFDDL, analytics) {
    for (var key in analytics) {
        SFDDL[key] = analytics[key];
    }
    return SFDDL;
};
